export const getOrderModalFromStorage = (): string | null => localStorage.getItem('orderModal');
